import React, {Component} from "react";
import PropTypes from "prop-types";
import CompanyForm from "./CompanyForm";
import * as companyActions from "../../actions/companyActions";
import * as pendingPageActions from "../../actions/pendingPageActions";
import * as modalActions from "../../actions/common/modalActions";
import {connect} from "react-redux";
import * as submitButtonActions from "../../actions/submit/submitButtonActions";
import * as settingsActions from "../../actions/settingsActions";
import * as companyRegionsActions from "../../actions/companyRegionsActions";
import * as countryActions from "../../actions/countryActions";
import * as companyMunicipalityActions from "../../actions/companyMunicipalityActions";
import * as vimeoActions from "../../actions/vimeoActions";
import * as portalContactActions from "../../actions/portal-contact/portalContactActions";
import * as companyTasksActions from "../../actions/companyTasks/companyTasksAction";
import * as companyCoverRegionsActions from "../../actions/company-cover-regions/companyCoverRegionsActions";
import {bindActionCreators} from "redux";
import CompanyInformationSelector from "../../reducers/company/CompanyInformationSelector";
import * as roles from "../../services/access/roles";
import CompanyFormSerializer from "../../services/CompanyFormSerializer";
import ReactSelectFormatter from "../../services/ReactSelectFormatter";
import {toastr} from "react-redux-toastr";
import {getFormValues, change} from "redux-form";
import {FormattedMessage, injectIntl} from "react-intl";
import {messages} from "../common/Translations";
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ArticleCategoriesSerializer from "../../services/ArticleCategoriesSerializer";
import {store} from "../../store/store";
import ResetFormModal from "../ResetFormModal";

class CompanyFormContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            companyId: this.props.match.params.id,
            uploadedImages: []
        };

        if (!this.state.companyId && this.props.user.company) {
            this.state.companyId = this.props.user.company.id;
        }

        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [
            // this.props.actions.loadCompanyCategories(this.state.companyId),
            this.props.actions.getSetting("COMPANY_KEYWORDS_COUNT"),
            this.props.actions.loadCompanyTasks(),
            this.props.actions.loadCompanyPortals(),
            this.props.actions.loadCountries(),
            this.props.actions.loadCompanyRegions(),
            this.props.actions.loadCompanyMunicipalities(),
            this.props.actions.loadCompanyCoverRegions(),
            this.props.actions.loadCompanyKeywordsPacks({
                'orderBy': 'keywordsCount',
                'direction': 'ASC'
            })
        ];

        if (this.isUpdate()) {
            actions.push(this.props.actions.getCompany(this.state.companyId));
            actions.push( this.props.actions.loadCompanyPortalContacts(
                "" + this.state.companyId + "?departmentId=5"
            ))
        }
        return actions;
    }

    componentDidMount() {
        if (!this.isUpdate()) {
            this.props.actions.resetCompany();
        }
    }

    componentWillReceiveProps(nextProp) {
        if (
            nextProp.formValues.vimeoId !== "" &&
            this.props.formValues.vimeoId !== nextProp.formValues.vimeoId &&
            this.props.company.id
        ) {
            let vimeoId = nextProp.formValues.vimeoId;
            this.props.actions.updateCompanyVimeo(this.props.company.id, {
                vimeoId
            });
        }

        if (nextProp.formValues.portal !== this.props.formValues.portal) {
            this.props.actions
                .loadCompanyArticleCategories(nextProp.formValues.portal)
                .then(() => {
                    let articleCategories = nextProp.formValues.articlesCategories.filter(
                        articleCategoryFromSelected => {
                            return store
                                .getState()
                                .articlesCategories.find(
                                    articleCategoryFromAll => {
                                        let selectedCategoryId = articleCategoryFromSelected;
                                        if (
                                            selectedCategoryId instanceof Object
                                        ) {
                                            selectedCategoryId =
                                                articleCategoryFromSelected.value;
                                        }

                                        return (
                                            articleCategoryFromAll.id ===
                                            selectedCategoryId
                                        );
                                    }
                                );
                        }
                    );

                    // clear article categories value
                    store.dispatch(
                        change(
                            "company",
                            "articlesCategories",
                            articleCategories
                        )
                    );
                });

            this.props.actions.loadCompanyCategories(
                nextProp.formValues.portal
            );
        }

        if (!nextProp.formValues
            || !Object.keys(nextProp.formValues).length
            || JSON.stringify(this.props.formValues.imagesExtra) === JSON.stringify(nextProp.formValues.imagesExtra)
        ) {
            return;
        }

        let imageExtraPromises = nextProp.formValues.imagesExtra.map(image => {
            return new Promise(function(resolve, reject){
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = function(e) {
                    resolve(reader.result);
                };
            });
        });

        if (imageExtraPromises.length) {
            Promise.all(imageExtraPromises)
                .then(image => image)
                .then(images => this.setState({uploadedImages: images}));
        }
        else {
            this.state.uploadedImages = [];
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }


    isUpdate() {
        return this.props.match.path.includes("rediger");
    }

    redirect() {
        if (this.props.user.isAdmin) {
            this.context.router.history.push("/virksomhed");
        }
    }

    submit(formFields) {

        if (formFields.vimeoId) {
            this.props.actions
                .updateVimeoVideo(formFields.vimeoId, {
                    name: formFields.vimeoName || formFields.name,
                    description: formFields.vimeoDescription
                })
                .then(() => {
                    this.sendForm(formFields);
                });
        } else {
            this.sendForm(formFields);
        }
    }

    sendForm(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let data = CompanyFormSerializer.serialize(
            formFields,
            this.props.categories
        );

        if (this.isUpdate()) {
            this.props.actions
                .updateCompany(this.state.companyId, data)
                .then(() => {
                    this.props.actions.hideSubmitButtonSpinner();
                    this.redirect();
                    toastr.success(
                        this.props.intl.formatMessage(messages.companyUpdated)
                    );
                })
                .catch(e => {
                    this.props.actions.hideSubmitButtonSpinner();
                });
        } else {
            this.props.actions
                .createCompany(data)
                .then(() => {
                    this.props.actions.hideSubmitButtonSpinner();
                    this.redirect();
                    toastr.success(
                        this.props.intl.formatMessage(messages.companyCreated)
                    );
                })
                .catch(e => {
                    this.props.actions.hideSubmitButtonSpinner();
                });
        }
    }

    render() {
        let {
            company,
            categories,
            specialBusinessCategories,
            portals,
            countries,
            regions,
            municipalities,
            addressSearchResult,
            isAdmin,
            portalContacts,
            keywordsCount,
            articlesCategories,
            companyTasks,
            companyCoverRegions,
            companyKeywordsPacks
        } = this.props;

        let title = this.props.intl.formatMessage(messages.companyCreate);
        if (this.isUpdate()) {
            title =
                this.props.intl.formatMessage(messages.companyUpdate) +
                " - " +
                company.name;
        }

        if (company.portal === "" && portals.length > 0) {
            company.portal = portals[0].value;
        }

        return (
            <WithResolvedPromises
                preloaderComponent={Placeholder}
                promises={this.actions}
                errorComponent={PlaceholderError}
            >
                <div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card m-b-20">
                                <div className="card-block">
                                    <h1 className="mb-3">{title}</h1>
                                    <CompanyForm
                                        initialValues={company}
                                        isUpdate={this.isUpdate()}
                                        categories={categories}
                                        specialBusinessCategories={specialBusinessCategories}
                                        portals={portals}
                                        countries={countries}
                                        regions={regions}
                                        municipalities={municipalities}
                                        addressSearchResult={
                                            addressSearchResult
                                        }
                                        articlesCategories={articlesCategories}
                                        isAdmin={isAdmin}
                                        portalContacts={portalContacts}
                                        onSubmit={this.submit}
                                        handleReset={this.handleReset}
                                        keywordsCount={keywordsCount}
                                        companyKeywordsPacks={companyKeywordsPacks}
                                        company={company}
                                        companyTasks={companyTasks}
                                        companyCoverRegions={companyCoverRegions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ResetFormModal
                        modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                        modalContent={
                            <p>
                                <FormattedMessage
                                    id="reset.modal.message"
                                    defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                                />
                            </p>}
                        confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                        closeText={this.props.intl.formatMessage(messages.buttonNo)}
                        handleConfirm={() => {
                            this.confirmReset()
                        }}
                    />
                </div>
            </WithResolvedPromises>
        );
    }
}

CompanyFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let formValues = Object.assign({}, getFormValues("company")(state));
    let company = state.company;
    company = CompanyFormSerializer.unserialize(company);

    let regions = CompanyInformationSelector.fillSelects(
        state.companyRegions,
        "regions"
    );
    let municipalities = Array.from(state.companyMunicipalities);
    municipalities = CompanyInformationSelector.filterMunicipalitiesByRegion(
        municipalities,
        company.regionId
    );

    municipalities = CompanyInformationSelector.fillSelects(
        municipalities,
        "municipalities"
    );
    let addressSearchResult = CompanyInformationSelector.fillSelects(
        state.addressSearchResults,
        "addresses"
    );
    let articlesCategories = ArticleCategoriesSerializer.unserialize(
        state.articlesCategories
    );

    let businessCategories = [];
    let specialBusinessCategories = [];

    for (let businessCategory of ReactSelectFormatter.formatCourseCategories(state.companyCategories)) {
        if (businessCategory.isSpecial) {
            specialBusinessCategories.push(businessCategory);
        } else {
            businessCategories.push(businessCategory);
        }
    }

    return {
        user: state.user,
        company,
        countries: state.countries,
        regions: regions,
        municipalities: municipalities,
        addressSearchResult,
        categories: businessCategories,
        specialBusinessCategories: specialBusinessCategories,
        portals: ReactSelectFormatter.format(state.companyPortals),
        companyKeywordsPacks: ReactSelectFormatter.formatKeywordsPacks(state.companyKeywordsPacks),
        isAdmin: state.user.roles.indexOf(roles.FBG_WEBMASTER) !== -1,
        formValues,
        portalContacts: state.companyPortalContacts,
        keywordsCount: state.setting.value,
        articlesCategories,
        companyTasks: state.companyTasks,
        companyCoverRegions: ReactSelectFormatter.format(state.companyCoverRegions)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                companyActions,
                modalActions,
                settingsActions,
                submitButtonActions,
                countryActions,
                companyRegionsActions,
                companyMunicipalityActions,
                pendingPageActions,
                vimeoActions,
                portalContactActions,
                companyTasksActions,
                companyCoverRegionsActions
            ),
            dispatch
        )
    };
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CompanyFormContainer)
);



// WEBPACK FOOTER //
// ./web/src/components/company/CompanyFormContainer.jsx